import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';

export default function Direction_Render(props) {
  const { setNodeData, nodeData } = props;
  const [directions, ] = useState(["front", "back", "left", "right"]);
  const [direction, setDirection] = useState(nodeData.type === 'direction' ? nodeData.selectedDirection: directions[0]);

  setNodeData({
    type: "direction",
    selectedDirection: direction
  })

  const handleChange = (event) => {
    setDirection(event.target.value)
    setNodeData({
      type: "direction",
      selectedDirection: event.target.value
    })
  }

  return(
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <TextField
    select
    id="outlined-required"
    label="Direction"
    defaultValue={direction}
    value={direction}
    name="robot_actions"
    style={{width: "100%"}}
    onChange={handleChange}
  >
  {directions.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ))}
  </TextField>
  </Grid>)
}